module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/4dRct3riqB0dvgLnUi3RrG-78d0a0068849cfe631a6b788006663f7.jpg";